import { render } from "./print.svg?vue&type=template&id=007645b5"
const script = {}
script.render = render

export default script